import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "CalibrationError", "$error_message$", config.defaultMessageId)